import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '../../common/enums/api-status';
import { createCompanyAsync, deleteCompanyAsync, toggleCompanyActivationAsync, updateCompanyAsync, getCompaniesAsync } from './companyThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const companySlice = createSlice({
    name: 'company',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCompaniesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCompaniesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.allCompanies = action.payload;
        })
            .addCase(getCompaniesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteCompanyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteCompanyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.company = action.payload;
        })
            .addCase(deleteCompanyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createCompanyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createCompanyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.company = action.payload;
            // Add the new company to the list immediately
            if (state.allCompanies) {
                state.allCompanies = [...state.allCompanies, action.payload];
            }
            else {
                state.allCompanies = [action.payload];
            }
        })
            .addCase(createCompanyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(toggleCompanyActivationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(toggleCompanyActivationAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(toggleCompanyActivationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateCompanyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCompanyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.company = action.payload;
        })
            .addCase(updateCompanyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default companySlice.reducer;
